import { getApiUrl } from "../utils/envConfig";
import { makeAuthenticatedRequest } from "./marketOverviewApi";
import type { components } from "./generated/schema";

export type WorkspaceConfig = components["schemas"]["WorkspaceConfigResponse"];

/** Fetch one workspace's presentation config. */
export const fetchWorkspaceConfigData = async (
  idClient: string
): Promise<WorkspaceConfig> => {
  const url = `${getApiUrl()}/workspaces/${encodeURIComponent(idClient)}/config`;
  return makeAuthenticatedRequest(url);
};
